import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../../../../../services/api";
import { ReportCloudSandbox } from "../../../../samples_cloud/@types";
import { sampleReportKeys } from "../../../queryKeys";

export const defaultSingleReportConfig = (
  hash: string,
  reportId: string,
  isNetworkReport = false
) => ({
  queryKey: sampleReportKeys.singleReportKey(hash, reportId, isNetworkReport),
  queryFn: () => api.rlSandboxSingleReport(hash, reportId, isNetworkReport),
  select: ({ data: respData }: AxiosResponse<ReportCloudSandbox>) => respData,
  refetchOnMount: false,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  retry: false
});
export const useGetSingleRlcsReport = (
  hash: string,
  reportId: string,
  isNetworkReport = false,
  options?: UseQueryOptions
) => {
  const {
    data,
    isLoading,
    refetch: refetchSingleReport,
    error,
    isFetched
  } = useQuery({
    ...defaultSingleReportConfig(hash, reportId, isNetworkReport),
    ...options
  });
  return {
    data: data as ReportCloudSandbox,
    isInitialLoading: isLoading,
    error,
    refetchSingleReport,
    isFetched
  };
};
